import onChange from 'on-change'
import { toAbsolutePath, isHover } from '../../helpers.js'

export default class PopupsMarkers {
  constructor(layers, map, mapState) {
    // Initialize properties
    this.layers = layers
    this.map = map
    this.mapState = mapState

    // Create a reactive state object with onChange library
    this.state = onChange({
      currentFeature: null
    }, this.handleStateChange.bind(this), {
      equals: (a, b) => a?.uuid === b?.uuid // Compare features by UUID to avoid unnecessary updates
    })
    
    // Initialize a Mapbox GL Popup
    this.popup = new mapboxgl.Popup({
      closeButton: false,
      closeOnClick: false,
      offset: [ 0, -22 ],
      maxWidth: '300px'
    })

    // Bind event handlers to the instance
    this.handleFeatureMousemove = this.handleFeatureMousemove.bind(this)
    this.handleFeatureMouseleave = this.handleFeatureMouseleave.bind(this)
    this.handleFeatureMouseclick = this.handleFeatureMouseclick.bind(this)
    this.handleFeatureTap = this.handleFeatureTap.bind(this)
    this.handleFeatureUntap = this.handleFeatureUntap.bind(this)

    // Add event listeners based on hover support
    if (isHover.matches) {
      this.map.on('mousemove', this.layers, this.handleFeatureMousemove)
      this.map.on('mouseleave', this.layers, this.handleFeatureMouseleave)  
      this.map.on('click', this.layers, this.handleFeatureMouseclick)
    } else {
      this.map.on('click', this.layers, this.handleFeatureTap)
      this.map.on('click', this.handleFeatureUntap)
    }
  }

  // Extract relevant feature data
  getFeatureData (feature) {
    return {
      uuid: feature?.properties?.uuid,
      source: feature?.source,
      tooltip: feature?.properties?.tooltip,
      coordinates: feature?.geometry?.coordinates
    }
  }

  // Handle mouse move over a feature
  handleFeatureMousemove (e) {
    if (e.features.length > 0) {
      this.state.currentFeature = this.getFeatureData(e.features[0])
    } else {
      this.state.currentFeature = null
    }
  }

  // Handle mouse leaving a feature
  handleFeatureMouseleave(e) {
    this.state.currentFeature = null;
  }

  // Handle mouse click on a feature
  handleFeatureMouseclick (e) {
    if (e.features.length > 0) {
      const linkTo = e.features[0]?.properties?.linkTo
      if (linkTo) {
        // Only close the popup on click if the feature has a linkTo property
        this.state.currentFeature = null 
      }
    }
  }

  // Handle touch tap on a feature
  handleFeatureTap (e) {
    e.preventDefault() // Prevent default to avoid firing Untap event simultaneously
    if (e.features.length > 0) {
      this.state.currentFeature = this.getFeatureData(e.features[0])
    }
  }

  // Handle touch untap on a feature
  handleFeatureUntap (e) {
    if (e.defaultPrevented === false) {
      this.state.currentFeature = null
    }
  }

  // Handle state changes
  handleStateChange(path, feature, previousFeature) {
    if (feature) {
      const { source, tooltip, coordinates } = feature;
      this.popup.setLngLat(coordinates)
        .setOffset([0, source === 'site-places' ? -16 : -22]) // Shift place down
        .setHTML(tooltip)
        .addTo(this.map);
    } else {
      this.popup.remove();
    }
  }
}
